let _commonService = {

    convertToYYYYMMDD(dateTimeStr) {
        const date = new Date(dateTimeStr);
        const year = date.getFullYear();
        const month = String(date.getMonth() + 1).padStart(2, '0');
        const day = String(date.getDate()).padStart(2, '0');

        return `${year}-${month}-${day}`;
    },

    convertToMMDDYYYY(dateTimeStr) {
        if (!dateTimeStr) return '';

        const date = new Date(dateTimeStr);

        if (isNaN(date.getTime())) return '';

        const month = String(date.getMonth() + 1).padStart(2, '0');
        const day = String(date.getDate()).padStart(2, '0');
        const year = date.getFullYear();

        return `${month}/${day}/${year}`;
    },

    formatDateWithSuffix(dateStr) {
        const date = new Date(dateStr);

        const day = date.getDate();
        const month = date.toLocaleString("default", { month: "short" });
        const year = date.getFullYear();

        // Determine ordinal suffix
        const getOrdinalSuffix = (n) => {
            if (n > 3 && n < 21) return "th";
            switch (n % 10) {
                case 1: return "st";
                case 2: return "nd";
                case 3: return "rd";
                default: return "th";
            }
        };

        const suffix = getOrdinalSuffix(day);
        return `${day}${suffix} ${month} ${year}`;
    },

    formatDateWithSuffixNew(dateStr) {
        const date = new Date(dateStr);

        const day = date.getDate();
        const month = date.toLocaleString("default", { month: "short" });
        const year = date.getFullYear();

        const getOrdinalSuffix = (n) => {
            if (n > 3 && n < 21) return "th";
            switch (n % 10) {
                case 1: return "st";
                case 2: return "nd";
                case 3: return "rd";
                default: return "th";
            }
        };

        const suffix = getOrdinalSuffix(day);
        return `${day}${suffix} ${month} ${year}`;
    },

    formatNumberWithCommas(value) {
        return value && value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    },

    formatDateTime(isoString) {
        const date = new Date(isoString);

        const pad = (n) => String(n).padStart(2, '0');

        const hours = pad(date.getHours());
        const minutes = pad(date.getMinutes());
        const seconds = pad(date.getSeconds());

        const day = pad(date.getDate());
        const month = pad(date.getMonth() + 1); // Month is 0-indexed
        const year = String(date.getFullYear()).slice(-2); // Get last 2 digits
        return `${hours}.${minutes}.${seconds} - ${day}/${month}/${year}`;
    },

    formatDateTimeAMPM(isoString) {
        const utcDate = new Date(isoString.endsWith('Z') ? isoString : isoString + 'Z');

        const options = {
            month: '2-digit',
            day: '2-digit',
            year: 'numeric',
            hour: '2-digit',
            minute: '2-digit',
            hour12: true,
        };

        return utcDate.toLocaleString('en-US', options);
    },

    // getCurrentMonthAndYear() {
    //     const now = new Date();
    //     return now.toLocaleString('en-US', { month: 'short', year: 'numeric' });
    // },

    getCurrentMonthAndYear() {
        const now = new Date();
        const day = now.getDate();

        // Determine day suffix
        const suffix =
            (day % 10 === 1 && day !== 11) ? "st" :
                (day % 10 === 2 && day !== 12) ? "nd" :
                    (day % 10 === 3 && day !== 13) ? "rd" : "th";

        const month = now.toLocaleString('en-US', { month: 'long' });
        const year = now.getFullYear();

        return `${month} ${day}${suffix}, ${year}`;
    },


    formatUSPhoneNumber(number) {
        // Convert the number to a string and remove any non-digit characters
        const cleaned = String(number).replace(/\D/g, '');

        // Ensure it has exactly 10 digits
        if (cleaned && cleaned.length !== 10) {
            throw new Error('Phone number must have exactly 10 digits');
        }

        // Format the number
        const formatted = `(${cleaned.slice(0, 3)}) ${cleaned.slice(3, 6)}-${cleaned.slice(6)}`;
        return formatted;
    },

    // Masks a sensitive number (SSN/ITIN, ID Number, etc.), keeping only the last 4
    // characters visible, e.g. "1234567891010" -> "*********1010".
    maskLast4Digits(value) {
        if (value === null || value === undefined) return value;
        const str = String(value);
        if (str.length <= 4) return str;
        return "*".repeat(str.length - 4) + str.slice(-4);
    }

};

export default _commonService;